/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type MailboxResponseProvider = typeof MailboxResponseProvider[keyof typeof MailboxResponseProvider];


export const MailboxResponseProvider = {
  google: 'google',
  microsoft: 'microsoft',
  imap: 'imap',
} as const;
